import { useEffect, useState } from "react";
import { formatRupiahNumber, formatDateTime } from "@/lib/format";
import { TiltCard } from "@/components/TiltCard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CAPI_BADGE = {
  sent: { label: "Terkirim", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-400/30" },
  skipped: { label: "Dilewati", cls: "bg-white/5 text-indigo-200/60 border-white/10" },
  failed: { label: "Gagal", cls: "bg-red-500/15 text-red-300 border-red-400/30" },
  pending: { label: "Diproses", cls: "bg-amber-500/15 text-amber-300 border-amber-400/30" },
};

export function HistoryView() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(false);

  const load = () => {
    fetch(`${API}/purchases`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((d) => {
        setItems(d.items || []);
        setError(false);
      })
      .catch(() => setError(true));
  };

  useEffect(load, []);

  return (
    <TiltCard
      data-testid="history-card"
      className="glass enter-up rounded-2xl px-4 py-6 sm:px-6"
    >
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-extrabold tracking-tight text-white">Riwayat</h2>
          <p className="mt-0.5 text-sm text-indigo-200/60">Transaksi manual & Excel</p>
        </div>
        <button
          type="button"
          data-testid="history-refresh-button"
          onClick={load}
          className="rounded-lg border border-white/15 px-3 py-1.5 text-xs font-semibold text-indigo-100 transition hover:border-indigo-400/50 hover:bg-indigo-500/20"
        >
          Muat ulang
        </button>
      </div>

      {error && (
        <p data-testid="history-error" className="mt-4 text-sm text-red-300">
          Data gagal dimuat. Coba lagi.
        </p>
      )}

      {items === null && !error && (
        <p data-testid="history-loading" className="mt-6 text-sm text-indigo-200/40">
          Memuat…
        </p>
      )}

      {items !== null && items.length === 0 && !error && (
        <p data-testid="history-empty" className="mt-6 text-sm text-indigo-200/40">
          Belum ada transaksi.
        </p>
      )}

      {items !== null && items.length > 0 && (
        <div className="mt-4 overflow-x-auto">
          <table data-testid="history-table" className="w-full text-left text-xs">
            <thead>
              <tr className="border-b border-white/10 text-indigo-200/50">
                <th className="whitespace-nowrap py-2 pr-3 font-semibold">Waktu</th>
                <th className="py-2 pr-3 font-semibold">Nama</th>
                <th className="py-2 pr-3 font-semibold">WhatsApp</th>
                <th className="whitespace-nowrap py-2 pr-3 font-semibold">Nominal</th>
                <th className="py-2 pr-3 font-semibold">Sumber</th>
                <th className="py-2 pr-3 font-semibold">Meta</th>
                <th className="py-2 font-semibold">Catatan</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => {
                const badge = CAPI_BADGE[it.meta_capi_status] || CAPI_BADGE.pending;
                return (
                  <tr
                    key={it.event_id}
                    data-testid={`history-row-${it.event_id}`}
                    className="border-b border-white/5 text-indigo-100/90"
                  >
                    <td className="whitespace-nowrap py-2.5 pr-3">
                      {formatDateTime(it.created_at)}
                    </td>
                    <td className="py-2.5 pr-3 font-medium text-white">{it.name}</td>
                    <td className="whitespace-nowrap py-2.5 pr-3">{it.phone}</td>
                    <td className="whitespace-nowrap py-2.5 pr-3 font-semibold">
                      {formatRupiahNumber(it.purchase_value)}
                    </td>
                    <td className="py-2.5 pr-3">
                      <span className="inline-block rounded-full border border-white/10 bg-white/5 px-2 py-0.5 text-[10px] font-semibold text-indigo-100">
                        {it.source === "excel" ? "Excel" : "Manual"}
                      </span>
                    </td>
                    <td className="py-2.5 pr-3">
                      <span
                        className={`inline-block rounded-full border px-2 py-0.5 text-[10px] font-semibold ${badge.cls}`}
                      >
                        {badge.label}
                      </span>
                    </td>
                    <td className="max-w-[160px] truncate py-2.5 text-indigo-200/60">
                      {it.notes || "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </TiltCard>
  );
}
